var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-template_textarea" },
    [
      _c(
        "div",
        { class: ["textarea_wrap", _vm.formatValueLength ? "is-active" : ""] },
        [
          _c(
            "div",
            { staticClass: "sub_content_wrap" },
            [
              _vm._t("header"),
              [
                _c(
                  "div",
                  { staticClass: "content_wrap" },
                  [
                    _vm.uploadedImages.length > 0
                      ? _c(
                          "div",
                          { staticClass: "image-preview-wrap" },
                          _vm._l(_vm.uploadedImages, function (image, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "image-preview-item" },
                              [
                                image.isImage
                                  ? _c("img", {
                                      attrs: {
                                        src: image.url,
                                        alt: image.name,
                                      },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "file-icon-placeholder" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-document",
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "file-ext" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getFileExtension(image.name)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                _c(
                                  "div",
                                  { staticClass: "image-preview-mask" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-delete",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeImage(index)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                image.uploading
                                  ? _c(
                                      "div",
                                      { staticClass: "upload-progress" },
                                      [
                                        _c("el-progress", {
                                          attrs: {
                                            percentage: image.progress,
                                            "show-text": false,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                image.uploadFailed
                                  ? _c(
                                      "div",
                                      { staticClass: "upload-failed" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _c(
                      _vm.formatSourceType,
                      _vm._g(
                        _vm._b(
                          {
                            ref: "content",
                            tag: "component",
                            attrs: { valueProp: _vm.value },
                            on: {
                              "update:valueProp": function ($event) {
                                _vm.value = $event
                              },
                              "update:value-prop": function ($event) {
                                _vm.value = $event
                              },
                              "on-key-up-enter": _vm.onKeyUpEnter,
                            },
                          },
                          "component",
                          _vm.$attrs,
                          false
                        ),
                        _vm.$listeners
                      )
                    ),
                    _c("div", { staticClass: "c-operate" }, [
                      _vm.$attrs.sourceType === "global"
                        ? _c(
                            "div",
                            { staticClass: "upload-btn" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "上传文件",
                                    effect: "dark",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "upload-wrap" }, [
                                    _c("input", {
                                      ref: "imageInput",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        type: "file",
                                        accept: ".png,.jpg,.jpeg",
                                        multiple: "",
                                      },
                                      on: { change: _vm.handleImageSelect },
                                    }),
                                    _c("img", {
                                      staticClass: "upload-icon",
                                      attrs: {
                                        src: require("@/components/aiChat/images/svg/uploadIcon.svg"),
                                      },
                                      on: { click: _vm.triggerImageUpload },
                                    }),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "send" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.loading ? "停止生成" : "发送",
                                effect: "dark",
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    "send_wrap",
                                    _vm.loading ? "is-stop" : "",
                                    _vm.isSendDisabled ? "is-disabled" : "",
                                  ],
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return (() => {
                                        _vm.isSendDisabled
                                          ? null
                                          : !_vm.isGtRange
                                          ? _vm.onSendQA({})
                                          : null
                                      }).apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "icon",
                                    attrs: {
                                      src: require("@/components/aiChat/images/svg/" +
                                        (_vm.loading
                                          ? "stopIcon"
                                          : _vm.isSendDisabled
                                          ? "defaultSendIcon"
                                          : !_vm.isGtRange
                                          ? _vm.tokenValueLength
                                            ? "sendIcon"
                                            : "defaultSendIcon"
                                          : "") +
                                        ".svg"),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
          _c("div", { staticClass: "bg_wrap" }),
        ]
      ),
      _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }